export const YMD_OUTPUT_FORMAT = 'yyyy/MM/dd';
export const YM_OUTPUT_FORMAT = 'yyyy/MM';
export const TIME_OUTPUT_FORMAT = 'HH:mm';
